import React, { useState } from 'react'
import "./Home.css"
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";


// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";

import leafSvg from "../../app/assets/images/icons/leaf.svg";
import userSvg from "../../app/assets/images/icons/supporting.svg"
import treeSvg from "../../app/assets/images/icons/tree.svg"
import petSvg from "../../app/assets/images/icons/pet.svg"
import birdImg from "../../app/assets/images/birders-wildlife-lovers.webp"
import natureImg from "../../app/assets/images/nature-seeker.webp"
import familiesImg from "../../app/assets/images/Familyretreat.jpg.webp"
import familiesImg2 from "../../app/assets/images/families.webp"
import schoolsImg from "../../app/assets/images/learning-img-2.jpg"
import arrowSvg from "../../app/assets/images/icons/arrow.svg"
import leafBlackSvg from "../../app/assets/images/icons/leaf-black.svg"
import homeSvg from "../../app/assets/images/icons/home-icon.svg"
import experienceSvg from "../../app/assets/images/icons/clock.svg"
import deepSvg from "../../app/assets/images/icons/heart.svg"
import rootSvg from "../../app/assets/images/icons/root.svg"
import slowForestImg from "../../app/assets/images/slow-forest.webp"
import guideTeach from "../../app/assets/images/guided-teach.webp"
import kumaonExperience from "../../app/assets/images/Village-over-view.webp"
import Gallery from '../../app/components/gallery-slider/Gallery';
import prevSvg from "../../app/assets/images/icons/previous.svg"
import nextSvg from "../../app/assets/images/icons/next.svg"
import starSvg from "../../app/assets/images/icons/star.svg"
// import bannerImg1 from "../../app/assets/images/banner-1.png"
// import bannerImg2 from "../../app/assets/images/cycling.webp"
// import bannerImg3 from "../../app/assets/images/nature-seekar.webp"
// import bannerImg4 from "../../app/assets/images/stay-rooted.webp"
// import bannerImg5 from "../../app/assets/images/slow-forest.webp"
// import bannerImg6 from "../../app/assets/images/nature-leads.webp"
// import bannerImg7 from "../../app/assets/images/look-closer.webp"
// import bannerImg8 from "../../app/assets/images/guided-teach.webp"
// import forestBreath from "../../app/assets/images/forest-breath.webp"
// import bannerImg1 from "../../app/assets/images/stay-banner.webp"
// import bannerImg2 from "../../app/assets/images/nature-seekar.webp"
// import bannerImg3 from "../../app/assets/images/travel-with-purpose.webp"
// import bannerImg4 from "../../app/assets/images/stay-rooted.webp"
// import bannerImg5 from "../../app/assets/images/experience-the-wild.webp"
// import bannerImg6 from "../../app/assets/images/where-nature-leads.webp"
// import bannerImg7 from "../../app/assets/images/slow-down.CR2"
// import bannerImg8 from "../../app/assets/images/feel-the-forest.webp"
// import bird from "../../app/assets/images/birdwatching.webp"
// import fourDay from "../../app/assets/images/riverside.webp"
// import mountaintrek from "../../app/assets/images/forest-breath.webp"

import forestBreath from "../../app/assets/images/forest-breath.webp"
import bannerImg1 from "../../app/assets/images/live-forest.webp"
import bannerImg2 from "../../app/assets/images/nature-seekar.webp"
import bannerImg3 from "../../app/assets/images/travel-with-purpose.JPG"
import bannerImg4 from "../../app/assets/images/stay-rooted.webp"
import bannerImg5 from "../../app/assets/images/experience-the-wild.webp"
import bannerImg6 from "../../app/assets/images/where-nature-leads.webp"
import bannerImg7 from "../../app/assets/images/slow-down.CR2"
import bannerImg8 from "../../app/assets/images/feel-the-forest.webp"
import bird from "../../app/assets/images/birdwatching.webp"
import fourDay from "../../app/assets/images/riverside.webp"
import mountaintrek from "../../app/assets/images/forest-breath.webp"
import { useNavigate } from 'react-router-dom';
import { openBooking } from '../../app/utils/links';
import familyRetreatImgs from "../../app/assets/images/Family-group.webp"
import slowForestRetreat from "../../app/assets/images/slow-forest-retreat.webp"
// This should be an array of image paths for the slider



const bannerData = [

  {
    id: 1,
    bgImage: bannerImg1,
    heading: <>Live in the <span>Forest</span></>,
    description: "Hidden in the forests of Kyari, in the Sitabani zone of Corbett, Camp Hornbill is a community run eco jungle lodge in Uttarakhand. Built by local villagers, this is a place where travel becomes more than a stay, it becomes a connection with nature, people, and a slower way of living. Wake up to birdsong, walk through forest trails, share meals with local families, and experience a space where every stay supports the land and the community that sustains it."
  },

  {
    id: 2,
    bgImage: bannerImg2,
    heading: <>Stay. Explore. <span>Connect.</span></>,
    description: "Hidden in the forests of Kyari, in the Sitabani zone of Corbett, Camp Hornbill is a community run eco jungle lodge in Uttarakhand. Built by local villagers, this is a place where travel becomes more than a stay, it becomes a connection with nature, people, and a slower way of living. Wake up to birdsong, walk through forest trails, share meals with local families, and experience a space where every stay supports the land and the community that sustains it."
  },



  {
    id: 3,
    bgImage: bannerImg3,
    heading: <>Travel with <span>Purpose</span></>,
    description: "Hidden in the forests of Kyari, in the Sitabani zone of Corbett, Camp Hornbill is a community run eco jungle lodge in Uttarakhand. Built by local villagers, this is a place where travel becomes more than a stay, it becomes a connection with nature, people, and a slower way of living. Wake up to birdsong, walk through forest trails, share meals with local families, and experience a space where every stay supports the land and the community that sustains it."
  },

  {
    id: 4,
    bgImage: bannerImg4,
    heading: <>Stay <span>Rooted</span></>,
    description: "Hidden in the forests of Kyari, in the Sitabani zone of Corbett, Camp Hornbill is a community run eco jungle lodge in Uttarakhand. Built by local villagers, this is a place where travel becomes more than a stay, it becomes a connection with nature, people, and a slower way of living. Wake up to birdsong, walk through forest trails, share meals with local families, and experience a space where every stay supports the land and the community that sustains it."
  },

  {
    id: 5,
    bgImage: bannerImg5,
    heading: <>Experience the <span>Wild</span></>,
    description: "Hidden in the forests of Kyari, in the Sitabani zone of Corbett, Camp Hornbill is a community run eco jungle lodge in Uttarakhand. Built by local villagers, this is a place where travel becomes more than a stay, it becomes a connection with nature, people, and a slower way of living. Wake up to birdsong, walk through forest trails, share meals with local families, and experience a space where every stay supports the land and the community that sustains it."
  },

  {
    id: 6,
    bgImage: bannerImg6,
    heading: <>Where Nature <span>Leads</span></>,
    description: "Hidden in the forests of Kyari, in the Sitabani zone of Corbett, Camp Hornbill is a community run eco jungle lodge in Uttarakhand. Built by local villagers, this is a place where travel becomes more than a stay, it becomes a connection with nature, people, and a slower way of living. Wake up to birdsong, walk through forest trails, share meals with local families, and experience a space where every stay supports the land and the community that sustains it."
  },

  {
    id: 7,
    bgImage: bannerImg7,
    heading: <>Slow Down. Look <span>Closer.</span></>,
    description: "Hidden in the forests of Kyari, in the Sitabani zone of Corbett, Camp Hornbill is a community run eco jungle lodge in Uttarakhand. Built by local villagers, this is a place where travel becomes more than a stay, it becomes a connection with nature, people, and a slower way of living. Wake up to birdsong, walk through forest trails, share meals with local families, and experience a space where every stay supports the land and the community that sustains it."
  },

  {
    id: 8,
    bgImage: bannerImg8, // Replace with your local image path
    heading: <>Feel the <span>Forest</span></>,
    description: "Hidden in the forests of Kyari, in the Sitabani zone of Corbett, Camp Hornbill is a community run eco jungle lodge in Uttarakhand. Built by local villagers, this is a place where travel becomes more than a stay, it becomes a connection with nature, people, and a slower way of living. Wake up to birdsong, walk through forest trails, share meals with local families, and experience a space where every stay supports the land and the community that sustains it."
  },
];


const experiences = [
  {
    title: "Morning Bird Walk",
    desc: "Start your day with the forest's first songs.",
    btn: "Explore",
    img: "https://images.unsplash.com/photo-1552728089-57bdde30ebd3?auto=format&fit=crop&w=400"
  },
  {
    title: "Guided Nature Trail",
    desc: "Walk slowly. Notice everything.",
    btn: "Discover",
    img: "https://images.unsplash.com/photo-1551632811-561732d1e306?auto=format&fit=crop&w=400"
  },
  {
    title: "Jungle Evenings",
    desc: "Where stories rise with the campfire.",
    btn: "Experience",
    img: "https://images.unsplash.com/photo-1552728089-57bdde30ebd3?auto=format&fit=crop&w=400"
  },
  {
    title: "Village Life Experience",
    desc: "Meet the people who call this forest home.",
    btn: "Learn More",
    img: "https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?auto=format&fit=crop&w=400"
  }
];




const targetAudience = [
  { title: "Birders & Wildlife Lovers", img: birdImg, text: "A perfect birdwatching lodge in Corbett with rich forest biodiversity" },
  { title: "Nature Seekers & Slow Travellers", img: natureImg, text: "A peaceful nature retreat in Uttarakhand, away from crowds" },
  { title: "Families", img: familiesImg, text: "Meaningful holidays with nature experiences and forest stays" },
  { title: "Schools & Learning Groups", img: schoolsImg, text: "Immersive nature learning camps in Uttarakhand" },
];


const whyPoints = [
  "A community-run eco friendly jungle lodge near Corbett National Park",
  "Stay in traditional mud cottages in Uttarakhand",
  "Designed for experiential travel and learning",
  "Deep connection with village life and local culture",
  "Rooted in sustainable tourism and conservation"
];

const itineraries = [
  { duration: "1 NIGHT & 2 DAYS", title: "Forest Sampler", desc: "A short and refreshing forest escape designed to slow you down and help you experience the rhythm of Camp Hornbill.", featured: false, img: require("../../app/assets/images/forest-sampler.webp") },
  { duration: "2 NIGHTS & 3 DAYS", title: "Roots & Woods", desc: "A balanced retreat blending forest experiences, village interactions, hands-on learning, and slow moments in nature.", featured: true, img: require("../../app/assets/images/roots&woods.webp") },
  { duration: "2 NIGHTS & 3 DAYS", title: "Call of the Wild", desc: "A balanced forest retreat combining wildlife safari, riverside experiences, nature walks, and slow moments in the outdoors.", featured: false, img: require("../../app/assets/images/experience-the-wild.webp") },
  { duration: "3 NIGHTS & 4 DAYS", title: "The Hornbill Experience", desc: "A deeper journey into the forests of Uttarakhand with wildlife safari, village experiences, riverside activities, and slow nature-based living.", featured: false, img: require("../../app/assets/images/Cycling.jpg.webp") },
];


const experienceses = [
  {
    title: "Hornbill Immersion Walks",
    desc: "A slow guided journey into the forest’s hidden rhythms.",
    img: require('../../app/assets/images/hornbill-immersion-walk.webp')
  },
  {
    title: "Slow Forest Retreat",
    desc: "Two days of birdsong and mindful wilderness living.",
    img: slowForestRetreat
  },
  {
    title: "Kumaon Nature Experience",
    desc: "Handcrafted moments designed to reconnect you with the wild.",
    img: kumaonExperience
  },
  {
    title: "Family Nature Escape",
    desc: "Gentle outdoor experiences for curious families.",
    img: familiesImg2
  }
];

const smallCards = [
  {
    title: "Nature & Ecology Camps",
    text: "Hands-on outdoor learning in rich forest environments.",
    image: require('../../app/assets/images/nature-ecology.webp')
  },
  {
    title: "School Programmes",
    text: "Structured modules aligned with educational objectives.",
    image: require('../../app/assets/images/school-programe.webp')
  },
  {
    title: "Guided Group Retreats",
    text: "Multi-day immersive experiences for student groups.",
    image: require('../../app/assets/images/nature-walks-2.webp')
  }
];


const sliderData = [
  {
    id: 1,
    image: bannerImg8,
    title: "Rooted in Conservation. Committed to Community.",
    description: "Our low-impact practices and local collaborations ensure that tourism here benefits both the forest and the people who call it home.",
  },
  {
    id: 2,
    image: forestBreath,
    title: "Where Every Stay Helps the Forest Breathe",
    description: "Through responsible tourism and community partnerships, we work to protect the fragile Kumaon ecosystem for generations to come.",
  },
];


const testimonials = [
  {
    id: 1,
    name: "ISHITA",
    role: "Guest",
    image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&q=80&w=200",
    text: "“Thanks to Naveen sir and his team. I visited this place twice in one year and definitely wish to visit again. All the staff are warm and the food is amazing. Esp. Kheer. They have so many activities for you that you'll never feel bored. The property is beautiful and so are the people managing it. Loved the experience. Thank you so much. Sustainable and purely environment friendly.”"
  },
  {
    id: 2,
    name: "ANANYA",
    role: "Traveler",
    image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?auto=format&fit=crop&q=80&w=200",
    text: "“An incredible experience! The ambiance was serene and the hospitality was top-notch. I highly recommend this place for anyone looking for a peaceful getaway.”"
  },
  {
    id: 3,
    name: "ROHAN",
    role: "Guest",
    image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&q=80&w=200",
    text: "“The staff was incredibly helpful and the food was home-style and delicious. A great initiative towards sustainability. Will definitely come back with family.”"
  },
  {
    id: 4,
    name: "MEHAK",
    role: "Guest",
    image: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&q=80&w=200",
    text: "“Beautiful property and very well maintained. The activities kept us engaged throughout the stay. The local cuisine served here is a must-try.”"
  },
  {
    id: 5,
    name: "VIKRAM",
    role: "Guest",
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?auto=format&fit=crop&q=80&w=200",
    text: "“Exactly what I needed for a weekend break. Purely environment friendly and very peaceful. Naveen and his team are doing a fantastic job.”"
  }
];



const inspriationData = [
  {
    id: 1,
    duration: "1 Night / 2 Days",
    title: "Weekend Birding Escape",
    description: "A relaxed short stay focused on guided bird walks and quiet forest exploration.",
    image: bird
  },
  {
    id: 2,
    duration: "4 Nights / 5 Days",
    title: "5-Day Slow Travel Journey",
    description: "An immersive itinerary blending village life, nature walks, and unhurried exploration.",
    image: bannerImg7
  },
  {
    id: 3,
    duration: "3-Day Programme",
    title: "School Nature Camp",
    description: "Structured outdoor learning designed for student groups and young explorers.",
    image: fourDay
  },
  {
    id: 4,
    duration: "3 Nights / 4 Days",
    title: "Mountain Trekking",
    description: "A challenging adventure through high peaks and scenic valley vistas.",
    image: mountaintrek
  }
];




function Home() {
  const [activeIndex, setActiveIndex] = useState(2);
  const navigate = useNavigate();
  const nextSlide = () => {
    setActiveIndex((prev) => (prev === testimonials.length - 1 ? 0 : prev + 1));
  };

  const prevSlide = () => {
    setActiveIndex((prev) => (prev === 0 ? testimonials.length - 1 : prev - 1));
  };

  const getPosition = (index) => {
    let diff = index - activeIndex;
    if (diff < -2) diff += testimonials.length;
    if (diff > 2) diff -= testimonials.length;
    return diff;
  };
  return (
    <>
      <section className="hero-banner-section bg-color">
        <Swiper
          modules={[Navigation, Autoplay]}
          navigation={{
            nextEl: '.swiper-button-next-custom',
            prevEl: '.swiper-button-prev-custom',
          }}
          // autoplay={{
          //   delay: 3000, 
          //   disableOnInteraction: false,
          // }}
          loop={true}
          className="mySwiper"
          style={{
            height: "100%"
          }}
        >
          {bannerData.map((slide) => (
            <SwiperSlide key={slide.id}>
              <div
                className="banner-item"
                style={{
                  backgroundImage: `linear-gradient(rgb(0 0 0 / 23%), rgb(0 0 0 / 32%)), url(${slide.bgImage})`,
                  backgroundSize: 'cover',
                  // backgroundPosition: 'top center',
                  backgroundPosition: '50% 25%',
                  backgroundRepeat: "no-repeat",
                  height: "100%",
                  display: 'flex',
                  alignItems: 'center'
                }}
              >
                <div className="container">
                  <div className="banner_wraper">
                    <h1 className="banner-heading">{slide.heading}</h1>
                    <p className="banner-content">
                      {slide.description}
                    </p>
                    <div className="btn-wraper d-flex gap-3">
                      <button className="primary_btn" onClick={()=>navigate("/family-retreats#journeys")}>Plan Your Forest Stay</button>
                      {/* <button className="outline_btn_white">Plan Your Forest Stay</button> */}
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}

          <div className="nav-controls custom-nav-pos d-flex gap-2">
            <button className="swiper-button-prev-custom swiper-nav-btn">
              <img loading="lazy" decoding="async" src={prevSvg} alt="Previous" />
            </button>
            <button className="swiper-button-next-custom swiper-nav-btn">
              <img loading="lazy" decoding="async" src={nextSvg} alt="Next" />
            </button>
          </div>
        </Swiper>

        {/* <Swiper
        modules={[Navigation, Autoplay]}
        navigation={{
            nextEl: '.swiper-button-next-custom',
            prevEl: '.swiper-button-prev-custom',
        }}
        loop={true}
        className="mySwiper"
        style={{ height: "100%" }}
    >
        {bannerData.map((slide) => (
            <SwiperSlide key={slide.id}>
                <div className="banner-item">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-6">
                                <div className="banner-image-container">
                                    <img loading="lazy" decoding="async" src={slide.bgImage} alt={slide.heading} className="banner-side-img" />
                                </div>
                            </div>


                            <div className="col-lg-6">
                                <div className="banner_wraper">
                                     <h1 className="banner-heading text-black">{slide.heading}</h1>
                                    <p className="banner-content text-black">
                                        {slide.description}
                                    </p>
                                    <div className="btn-wraper d-flex gap-3">
                                        <button className="primary_btn">Plan Your Visit</button>
                                        <button className="outline_btn">Plan Your Forest Stay</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </SwiperSlide>
        ))}

      
        <div className="nav-controls custom-nav-pos d-flex gap-2">
            <button className="swiper-button-prev-custom swiper-nav-btn">
                <img loading="lazy" decoding="async" src={prevSvg} alt="Previous" />
            </button>
            <button className="swiper-button-next-custom swiper-nav-btn">
                <img loading="lazy" decoding="async" src={nextSvg} alt="Next" />
            </button>
        </div>
    </Swiper> */}
      </section>

      <div className="stats-bar">
        <div className="container">
          <div className="row text-center">
            <div className="col-lg-3 col-md-4 col-12 stat-item">
              <img loading="lazy" decoding="async" src={leafSvg} alt="Experience Icon" className="me-2" /> 15+ Years of Community Hospitality
            </div>
            <div className="col-lg-3 col-md-4 col-12 stat-item">
              <img loading="lazy" decoding="async" src={userSvg} alt="Supporting Icon" className="me-2" /> Supporting 30+ Local Livelihoods
            </div>
            <div className="col-lg-3 col-md-4 col-12 stat-item">
              <img loading="lazy" decoding="async" src={treeSvg} alt="Tree Icon" className="me-2" /> 70% Land Preserved as Forest
            </div>
            <div className="col-lg-3 col-md-4 col-12 stat-item">
              <img loading="lazy" decoding="async" src={petSvg} alt="Pet Icon" className="me-2" /> Pet-Friendly Forest Stay
            </div>
          </div>
        </div>
      </div>

      <section className="section-padding bg-white">
        <div className="container">
          <div className="row  bg-color">
            <div className="col-lg-6 col-md-12 col-12 g-0">
              <div className="h-100">
              <img loading="lazy" decoding="async" src={require("../../app/assets/images/about.png")} className="img-fluid shadow h-100 w-100 object-fit" alt="About Camp" />
              </div>
            </div>
            <div className="col-lg-6 col-md-12 col-12 ">
              <div className="about-bx h-100">
              <h2 className="heading">About us</h2>
              <p className='content'>Camp Hornbill is a community-led enterprise, set up in 2010 by residents of the village Kyari. It lies within the Sitabani Conservation Reserve (SCR). The SCR is part of the larger Corbett Tiger Reserve in Uttarakhand, India. The camp is solely owned and managed by members and the youth of the local community. It was established with a vision to promote and encourage eco-tourism in the village of Kyari.</p>
              <p className='content'>Camp Hornbill actively promotes nature conservation and rural development in the Corbett Tiger Reserve in collaboration with the forest department, local communities and members of the civil society. Camp Hornbill is a community of like-minded individuals with many years of experience in the sectors of conservation, eco-tourism, and business development. At Camp Hornbill, our aim is to seed an alternative form of nature travel that is responsible and contributes to nature conservation and community development.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section-padding" style={{ backgroundColor: 'var(--bg-color)' }}>
        <div className="container text-center">
          <div className='heading-content-wraper'>
            <h2 className="heading">Who This Is <span >For</span></h2>
            <div className='diveder-bx'></div>
            <p className="content">Slow, meaningful ways to connect with the wild.</p>
          </div>
          <div className="row g-4">
            {targetAudience.map((item, index) => (
              <div className="col-lg-3 col-md-4 col-12" key={index}>
                <div className="info-card bg-white h-100 shadow-sm border-0">
                  <img loading="lazy" decoding="async" src={item.img} alt={item.title} className="card-img-top" />
                  <div className="info-card-body p-3 text-start">
                    <h6 className="sub-heading">{item.title}</h6>
                    <p className="content">{item.text}</p>
                    {/* <a className="explore-text text-decoration-none">
                      Explore
                      <img loading="lazy" decoding="async" src={arrowSvg} className='arrow-img' alt='arrow' />
                    </a> */}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section-padding">
        <div className="container">
          <div className="row align-items-center bg-color">
            <div className="col-md-6">
              <div className='p-25'>
                <h2 className="heading">Why Camp Hornbill?</h2>
                <ul className="list-unstyled mt-4">
                  {whyPoints.map((point, index) => (
                    <li className="content mb-3 d-flex align-items-center" key={index}>
                      <img loading="lazy" decoding="async" src={leafBlackSvg} alt="Leaf Icon" className="me-2" style={{ width: '20px' }} />
                      {point}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            <div className="col-md-6 g-0">
              <img loading="lazy" decoding="async" src={require("../../app/assets/images/why-camphornbill.webp")} className="img-fluid shadow-sm" alt="Lodge" />
            </div>
          </div>
        </div>
      </section>

      <section className="section-padding bg-color">
        <div className="container">
          {/* Header */}
          <div className="heading-content-wraper text-center">
            <h2 className='heading'>Discover the Forest Through <span>Curated Experiences</span></h2>
            <div className="diveder-bx"></div>
            <p className="content">
              Signature experiences designed to slow you down and reconnect you with the wild.
            </p>
          </div>

          <div className="row g-4">
            {/* Left Side: Large Vertical Media */}
            <div className="col-lg-4">
              <div className="video-container shadow-sm">
                <img loading="lazy" decoding="async"
                  src={require("../../app/assets/images/experience-img.webp")}
                  alt="Forest Sunrays"
                />
              </div>
            </div>

            {/* Right Side: 2x2 Grid */}
            <div className="col-lg-8">
              <div className="row">
                {experienceses.map((item, index) => (
                  <div className="col-md-6 mb-4" key={index}>
                    <div className="experience-card">
                      <div className='img-wrapper'>
                        <img loading="lazy" decoding="async" src={item.img} alt={item.title} className="shadow-sm" />
                      </div>
                      <h4 className='sub-heading'>{item.title}</h4>
                      <p className='content'>{item.desc}</p>
                      {/* <a className="explore-text text-decoration-none">
                        Explore
                        <img loading="lazy" decoding="async" src={arrowSvg} className='arrow-img' alt='arrow' />
                      </a> */}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="learning-section">
        <div className="container">
          <div className="row g-4 align-items-stretch">
            {/* Left Column: 3 Small Vertical Cards */}
            <div className="col-lg-6">
              <div className="learning-header">
                <h2 className='heading'><span>Learning</span> & Groups</h2>
                <div className="diveder-bx"></div>
              </div>
              <div className="row g-3">
                {smallCards.map((card, index) => (
                  <div className="col-md-4" key={index}>
                    <div className="info-card bg-white h-100 shadow-sm border-0">
                  <img loading="lazy" decoding="async" src={card.image} alt="Image" className="card-img-top" />
                  <div className="info-card-body p-3 text-start">
                    <h6 className="sub-heading">{card.title}</h6>
                    <p className="content">{card.text}</p>
                  </div>
                </div>
                    {/* <div
                      className="overlay-card"
                      style={{ backgroundImage: `url(${card.image})` }}
                    >
                      <div className="card-content">
                        <h4 className="mb-3">{card.title}</h4>
                        <p className='mb-0'>{card.text}</p>
                      </div>
                    </div> */}
                  </div>
                ))}
              </div>
            </div>

            {/* Right Column: 1 Large Horizontal Card */}
            <div className="col-lg-6">
              <div
              className="info-card bg-white h-100 shadow-sm border-0"
                // className="overlay-card large-retreat-card"
                // style={{ backgroundImage: `url(${familyRetreatImgs})` }}
              >
                <img loading="lazy" decoding="async" src={familyRetreatImgs} alt="Image" className="card-img-top" style={{height: "350px"}} />
                 <div className="info-card-body p-3 text-start">
                    <h6 className="sub-heading">Family Nature Retreats</h6>
                    <p className="content">
                      Meaningful forest experiences designed for families to slow down, explore, and reconnect together.
                    </p>
                    <button className="primary_btn" onClick={() => navigate("/family-retreats#journeys")}>
                      Explore Family Retreats
                    </button>
                  </div>
                {/* <div className="card-content">
                  <h3 className='heading text-white'>Family Nature Retreats</h3>
                  <p className='content text-white'>
                    Meaningful forest experiences designed for families to slow down, explore, and reconnect together.
                  </p>
                  <button className="primary_btn">Explore Family Retreats</button>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className='section-padding'>
        <div className="heading-content-wraper text-center">
          <p className='top-heading'>Stay With Us</p>
          <h2 className='heading'><span>Mud</span> & <span>Stone Cottages</span> Rooted in the Forest</h2>
          <div className="diveder-bx"></div>
          <p className="content">
            Wake up to birdsong, sunlight, and the slow rhythm of the forest.
          </p>
        </div>
        <Gallery />
        <div className='d-flex justify-content-center'>
          <button className='primary_btn' onClick={() => navigate("/stay#cottages")}> View Cottages</button>
        </div>
      </section>

      <section className="section-padding">
        <div className="container">
          <div className="text-center mb-5">
            <h2 className="heading">Slow Holidays. Deeper <span>Connections.</span></h2>
            <div className='diveder-bx'></div>
            <p className="content">Curated forest journeys near Jim Corbett for families and mindful travellers.</p>
          </div>
          <div className="row g-4">
            {itineraries.map((plan, index) => (
              <div className="col-md-4 col-12" key={index}>
                <div className="info-card bg-white h-100 shadow-sm border-0">
                  <img loading="lazy" decoding="async" src={plan.img} alt="Images" className="card-img-top" />
                  <div className="info-card-body p-3 text-start">
                     <span className="badge mb-3 " style={{ width: 'fit-content' }}>
                    {plan.duration}
                  </span>
                    <h6 className="sub-heading">{plan.title}</h6>
                    <p className="content">{plan.desc}</p>
                    {plan.featured ? (
                      <button className="primary_btn w-100" onClick={()=> navigate("/family-retreats")}>View Details</button>
                    ) : (
                      <button className="outline_btn px-4 w-100" onClick={()=> navigate("/family-retreats")}>View Details</button>
                    )}
                  </div>
                </div>
                {/* <div
                  className={`card p-4 border-0 shadow-sm h-100 featured-card`}
                >
                  <span className="badge mb-3 " style={{ width: 'fit-content' }}>
                    {plan.duration}
                  </span>
                  <h5 className="heading">{plan.title}</h5>
                  <p className="content mb-4">{plan.desc}</p>
                  <div className="mt-auto d-flex justify-content-center">
                    {plan.featured ? (
                      <button className="primary_btn w-100" onClick={()=> navigate("/family-retreats")}>View Itinerary</button>
                    ) : (
                      <button className="outline_btn px-4 w-100" onClick={()=> navigate("/family-retreats")}>View Itinerary</button>
                    )}
                  </div>
                </div> */}
              </div>
            ))}
          </div>
          {/* <div className="text-center mt-5">
            <button className="primary_btn">Explore All Journeys</button>
          </div> */}
        </div>
      </section>

     

      <section className='section-padding'>
        <div className='container'>
          <div className="heading-content-wraper text-center">
            <h2 className='heading'>What Our <span>Guests Say</span></h2>
            <div className="diveder-bx"></div>
            <p className="content">
              We take pride in serving our guests with the best experience. Read what they say.
            </p>
          </div>
          {/* <div className='bg-color testimonail-slider-wraper'>
            <div className="slider-wrapper d-flex align-items-center justify-content-center mb-5">
              <button className="nav_btn me-3 previmg" onClick={prevSlide}>
                <img loading="lazy" decoding="async" src={prevSvg} alt="images"/>
              </button>

              <div className="images-container">
                {testimonials.map((item, index) => {
                  const pos = getPosition(index);
                  const isCenter = pos === 0;
                  const isVisible = Math.abs(pos) <= 2;

                  if (!isVisible) return null;

                  return (
                    <>
                    <div
                      key={item.id}
                      className={`testimonial-img-wrapper pos-${pos} ${isCenter ? 'active' : ''}`}
                    >
                      <img loading="lazy" decoding="async" src={item.image} alt={item.name} className="testimonial-img" />
                    </div>
                    </>
                  );
                })}
              </div>

              <button className="nav_btn ms-3 nextimg" onClick={nextSlide}>
                <img loading="lazy" decoding="async" src={nextSvg} alt="images"/>
              </button>
            </div>


            <div className="row justify-content-center">
              <div className="col-md-8">
                <p className="testimonial-text mb-4">
                  {testimonials[activeIndex].text}
                </p>

                <div className="d-flex justify-content-center gap-1">
                    <img loading="lazy" decoding="async" src={starSvg} alt='image' />            
                </div>
              </div>
            </div>
            </div> */}

          <div className="elfsight-app-ecf8f425-03bd-4824-bf60-9be9e7648f75" data-elfsight-app-lazy></div>
        </div>
      </section>


      <section className='slow-sec section-padding'>
        <div className='container'><div className="heading-content-wraper text-center position-relative z-2">
          <p className='top-heading text-white'>Plan Your Journey</p>
          <h2 className='heading text-white'>Ready to Experience Kumaon the Slow Way?</h2>
          <div className="diveder-bx2"></div>
          <p className="content text-white">
            Let us help you craft the right experience for your time in the forest.
          </p>
        </div>
          <div className='position-relative z-2 d-flex justify-content-center gap-3'>
            <button className='primary_btn' onClick={openBooking}>Plan Your Journey</button>
            {/* <button className='btn btn-outline-white'>Talk to Us</button> */}
          </div>
        </div>
      </section>
    </>
  )
}

export default Home